import "@/App.css";
import React, { useEffect } from "react";
import { BrowserRouter, Navigate, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import { ProtectedRoute } from "@/pages/admin/DashboardLayout";

import Home from "@/pages/public/Home";
import Catalog from "@/pages/public/Catalog";
import ProductDetail from "@/pages/public/ProductDetail";
import OrderFlow from "@/pages/public/OrderFlow";
import Confirmation from "@/pages/public/Confirmation";
import Services from "@/pages/public/Services";
import Favoritos from "@/pages/public/Favoritos";
import Cart from "@/pages/public/Cart";

import Login from "@/pages/admin/Login";
import Resumen from "@/pages/admin/Resumen";
import Pedidos from "@/pages/admin/Pedidos";
import Calendario from "@/pages/admin/Calendario";
import Clientes from "@/pages/admin/Clientes";
import Pagos from "@/pages/admin/Pagos";
import Disponibilidad from "@/pages/admin/Disponibilidad";
import Catalogo from "@/pages/admin/Catalogo";
import Servicios from "@/pages/admin/Servicios";
import Configuracion from "@/pages/admin/Configuracion";

const P = (C) => <ProtectedRoute>{C}</ProtectedRoute>;
const ADMIN_APP_MODE = process.env.REACT_APP_APP_MODE === "admin";
const ADMIN_ROUTES = (
  <>
    <Route path="/admin/login" element={<Login />} />
    <Route path="/admin" element={P(<Resumen />)} />
    <Route path="/admin/pedidos" element={P(<Pedidos />)} />
    <Route path="/admin/calendario" element={P(<Calendario />)} />
    <Route path="/admin/clientes" element={P(<Clientes />)} />
    <Route path="/admin/pagos" element={P(<Pagos />)} />
    <Route path="/admin/disponibilidad" element={P(<Disponibilidad />)} />
    <Route path="/admin/catalogo" element={P(<Catalogo />)} />
    <Route path="/admin/servicios" element={P(<Servicios />)} />
    <Route path="/admin/configuracion" element={P(<Configuracion />)} />
  </>
);

function ScrollToTop() {
  const { pathname, search } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, [pathname, search]);

  return null;
}

function App() {
  if (ADMIN_APP_MODE) {
    return (
      <AuthProvider>
        <BrowserRouter>
          <ScrollToTop />
          <Toaster position="top-center" richColors />
          <Routes>
            <Route path="/" element={<Navigate to="/admin/login" replace />} />
            {ADMIN_ROUTES}
            <Route path="*" element={<Navigate to="/admin" replace />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    );
  }

  return (
    <AuthProvider>
      <BrowserRouter>
        <ScrollToTop />
        <Toaster position="top-center" richColors />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/catalogo" element={<Catalog />} />
          <Route path="/producto/:id" element={<ProductDetail />} />
          <Route path="/pedido" element={<OrderFlow />} />
          <Route path="/confirmacion" element={<Confirmation />} />
          <Route path="/servicios" element={<Services />} />
          <Route path="/favoritos" element={<Favoritos />} />
          <Route path="/carrito" element={<Cart />} />
          {ADMIN_ROUTES}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
